import { createSelector } from 'reselect'
import { State } from 'interfaces/state'
import { createOwnPropsSelector } from 'selectors/globalSelectors'
import { OfferPageInnerProps } from 'components/features/pfm/OfferPage/OfferPage'

export const offersSelector = (state: State) =>
  state.data.offers

export const offerSelector = createSelector(
  offersSelector,
  createOwnPropsSelector<OfferPageInnerProps>(),
  (offers, ownProps) =>
    offers && ownProps.match.params.id
      ? offers.byKey[ownProps.match.params.id]
      : null
)
